import { render, staticRenderFns } from "./TypesTableMobile.vue?vue&type=template&id=783ff838&scoped=true&lang=pug&"
import script from "./TypesTableMobile.vue?vue&type=script&lang=js&"
export * from "./TypesTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./TypesTableMobile.vue?vue&type=style&index=0&id=783ff838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ff838",
  null
  
)

export default component.exports